import moment from "moment-timezone";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiResponse } from "../../../api/apiResponse";
import { updateCandidateQualification } from "../../../api/endpoints/tutors/candidates";
import { updateTutorSession } from "../../../api/endpoints/tutors/sessions";
import SessionModel from "../../../api/models/SessionModel";
import { makeApiRequest } from "../../../helpers";
import AppButton from "../../buttons/AppButton";
import Modal from "../ModalWithFooter";
import useTimeout from "../../../hooks/useTimeout";
import toast from "react-hot-toast";
import ExistConfirmationModal from "../ExistSessionModal";
import { useTelawah } from "../../../hooks/useTelawah";
import { sessionLearnerEvaluations } from "../../../api/endpoints/tutors/sessionEvaluations";

type EndSessionNewBoardingProps = {
  isOpen: boolean;
  onClose: () => void;
  session: SessionModel;
  onEndSession: () => void;
};
export default function EndSessionNewBoarding(
  props: EndSessionNewBoardingProps
) {
  const { isOpen, onClose: onCloseModal, session, onEndSession } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.tutor.dashboard.room",
  });
  const [isQualified, setIsQualified] = useState<string | undefined>(undefined);
  const [pages, setPages] = useState<string | number | undefined>();
  const { telawahs, getTelawahById } = useTelawah();
  const onClose = () => {
    setIsQualified(undefined);
    setPages(0);
    onCloseModal();
  };
  const updateSessionStatus = async () => {
    await makeApiRequest(
      () =>
        updateTutorSession(session.id, {
          end_time: moment(),
          reported_status: "completed",
        }),
      (response: ApiResponse) => {
        onEndSession();
        onClose();
      }
    );
  };

  const updateQualifiedStatus = async () => {
    await makeApiRequest(
      () =>
        sessionLearnerEvaluations(session.id, {
          student_id: session.student?.id,
          result: isQualified,
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) updateSessionStatus();
      }
    );
  };
  const confirmEndSession = (confirm: boolean) => {
    if (confirm) {
      updateQualifiedStatus();
      if (!!onEndSession) onEndSession();
    }
  };

  return (
    <Modal open={isOpen} setOpen={onClose}>
      <Modal.Body setOpen={onClose} title={t("endSession")}>
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium text-gray-700">
            {t("isLearnerQualified", {
              student: session.student?.name,
              telawah: getTelawahById(session.student?.telawah_id! as any)?.[0]
                ?.name,
            })}
          </p>
          <div className="flex gap-8 py-[9px]">
            <div className="flex items-center gap-2">
              <input
                id="qualified"
                name="notification-method"
                type="radio"
                checked={isQualified === "approved"}
                onChange={() => setIsQualified("approved")}
                className="h-4 w-4 border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
              />
              <label
                htmlFor="qualified"
                className="block text-sm font-medium text-gray-700"
              >
                {t("yes")}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                id="not-qualified"
                name="notification-method"
                type="radio"
                checked={isQualified === "rejected"}
                onChange={() => setIsQualified("rejected")}
                className="h-4 w-4 border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
              />
              <label
                htmlFor="not-qualified"
                className="block text-sm font-medium text-gray-700"
              >
                {t("notYet")}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                id="not-attend"
                name="notification-method"
                type="radio"
                checked={isQualified === "absent"}
                onChange={() => setIsQualified("absent")}
                className="h-4 w-4 border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
              />
              <label
                htmlFor="not-attend"
                className="block text-sm font-medium text-gray-700"
              >
                {t("notAttend")}
              </label>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-4 px-2">
          <AppButton buttonShape="secondary" onClick={onClose}>
            {t("cancel")}
          </AppButton>
          <AppButton
            buttonShape="primary-danger"
            onClick={() => confirmEndSession(true)}
            disabled={isQualified === undefined}
          >
            {t("endSession")}
          </AppButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
